import { InferenceProvider } from "services/ApiServiceProviders";

export const streamProvidersInferenceStatus = ({ params }) => {
  return InferenceProvider.clientSSE
    .get(`/projects/${params.id}/inference/${params.alias}/status`)
    .then((response) => {
      return response;
    })
    .catch((error) => error.response);
};

export const streamProvidersCompletionStatus = ({ params }) => {
  return InferenceProvider.clientSSE
    .get(`/projects/${params.id}/status`)
    .then((response) => {
      return response;
    })
    .catch((error) => error.response);
};
